import { Navigate, Outlet } from 'react-router-dom'
import React from 'react'
import { useAuth } from '../contexts/AuthContext'

type Props = {
    allowedRoles: string[]
}

const ProtectedRoute: React.FC<Props> = ({ allowedRoles }) => {
    const { role, loggedIn } = useAuth()

    if (!loggedIn) {
        // nicht eingeloggt → Login-Seite
        return <Navigate to="/login" replace />
    }

    if (!allowedRoles.includes(role)) {
        // eingeloggt, aber falsche Rolle → Unauthorized-Seite
        return <Navigate to="/login" replace />
    }

    return <Outlet />
}

export default ProtectedRoute
